module.exports = __webpack_public_path__ + "img/hint_phone_close_screen.096a3035.png";